/**
 * Check if a mailing list is the system-managed 'Profile subscribers' list.
 */
export function isProfileSubscribersList(
  list?: { list_type?: string; name?: string } | null,
): boolean {
  if (list?.list_type === 'profile_subscribers') {
    return true;
  }
  return Boolean(list?.name && list.name.trim().toLowerCase() === 'profile subscribers');
}
